/**
 * 任意の URL へブラウザを遷移させる薄いラッパー。
 *
 * `window.location.assign` は jest-fixed-jsdom 環境では read-only / 非 configurable
 * のためテストから直接モックできない。テスト側でこのモジュールを `jest.mock` できる
 * よう、関数として切り出している。
 */
export const navigateTo = (url: string): void => {
  window.location.assign(url);
};
